import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserRoleMenu } from 'projects/Administration/src/app/business-entities/user-role-menu.model';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { RentalCar } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { Subscription } from 'rxjs';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { DocumentPartStatus } from 'projects/Administration/src/app/business-entities/appointmentStatus-model';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { DealerOpeningHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-opening-hours-view-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnholdStatusChangeComponent } from 'projects/Administration/src/app/components/onhold-status-change/onhold-status-change.component';
import { CancelStatusChangeComponent } from 'projects/Administration/src/app/components/cancel-status-change/cancel-status-change.component';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { TranslateService } from '@ngx-translate/core';
import { ClipboardService } from 'ngx-clipboard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { AppLinkService } from 'projects/Administration/src/app/business-services/app-link.service';
import { ToastrService } from 'ngx-toastr';
import { CountryISO } from 'ngx-intl-tel-input-gg';

@Component({
  selector: 'app-bnh-appointment-general-information',
  templateUrl: './bnh-appointment-general-information.component.html',
  styleUrls: ['./bnh-appointment-general-information.component.css']
})
export class BnhAppointmentGeneralInformationComponent implements OnInit {
  isCurrentAppointmentOnHold: boolean = false;
  userRoleRightsDetails: UserRoleMenu;
  userRoleRightsDetailsVehicle: UserRoleMenu;
  previousStatus: any;
  previousDocumentStatus: any;
  featureList: Features[] = [];
  closeResult: string;
  isDocumentPartStatusActive: boolean = false;
  isToAddRentalCarAsDemand: boolean = false;
  isShiftAppointment: boolean = false;
  isDMSEnable: boolean = false;
  selectedRentalCarId: number;
  contactDetailsCopiedData: AppointmentDetail;
  licensePlateClass: string;
  selectedRentalCarDetail: RentalCar;
  currentlagSub: Subscription;
  isShareBoxEnabled: boolean = false;
  SelectedStatus: any = null;
  StatusDisabled: boolean = false;
  isQuote: boolean = false;
  appointmentStatusName: string;
  isRentalCar: boolean = false;
  selectedGenericRentalCarId: number;
  FinishMinutes: string;
  EUControlClass: string;
  dealerWorkingHours: DealerOpeningHoursViewModel[];
  IsonHoldStatus: boolean = false;
  appointmentUpdatedDate: any;
  CustomerDropTimeDropDownValues: any = [];
  CustomerPickUpTimeDropDownValues: any = [];
  isShowGenerateTrackerButton: boolean = false;
  statusTrackerUrl: any;
  salesPersonList = [];
  SelectedSalesPerson: any = null;
  documentPartStatus: DocumentPartStatus[];
  serviceDetail: AppointmentServiceDetails;
  RentalCarValidationCheckBox: boolean = false;
  formattedTotalTime: string;
  VatSub: Subscription;
  VAT: number = 0;
  isDsoActive: boolean = false;
  isNeedAttention: boolean = false;  
  isDiscountCodeActive: boolean = false;
  isTireHotelActive: boolean = false;
  DateClass: string;
  DefaultStartTime: string;
  DefaultEndTime: string;
  deafultDialCode: string;
  isDmsPackageSync: boolean = false;
  @Output() onGetContactDetails = new EventEmitter<AppointmentDetail>();
  @Output() updatedAppointmentDetails = new EventEmitter<any>();
  @Output() isRefreshTab = new EventEmitter<boolean>();
  @Output() unselectRentalCar = new EventEmitter<boolean>();
  @Input() isWorkOrderHistory: boolean;
  editcommentform: FormGroup;
  commentType: any;
  internalComments: any;
  editCommentText: any;
  editCommentId: any;
  closeModel: any;
  CountryISO = CountryISO;
  isInitialLoad: boolean = true;
  onlyCountries: string[] = [];
  countryDialCodes: any[] = [];
  selectedContactCountryISO = this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedSellCountryISO = this.cultureLocaleService.getLocale() || CountryISO.Norway;
  serviceCampaignOptionList:any;
  selectedCampaignService:number = 1;
  isHoveredInternalComment = false;
  isHoveredCustomerComment = false;
  isHoveredMechanicComment = false;
  availableTransport:any;
  // ngx-intl-tel-input writes its own ChangeData object back through [(ngModel)], so the
  // controls must bind to these local models instead of commonService.singlePhoneNo /
  // commonService.mobileNo - otherwise the object lands back in the input on re-render
  // and the browser prints it as [object Object]. Initialised once by initMobileNumbers().
  contactMobileNo: any;
  sellToCustomerMobileNo: any;
  mobileInitialized = false;
  constructor(
    public editAppointmentService: EditAppointmentService,
    public settingService: SettingService,
    private readonly spinner: NgxSpinnerService,
    public workOrderService: AppointmentWorkOrderService,
    private readonly globalSetting: GlobalSetting,
    private readonly secureStorage: SecureStorage,
    public dealerBusinessService: DealerBusinessService,
    private readonly userService: UserDataService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly modalService: NgbModal,
    public commonService: AppointmentCommonService,
    private readonly appointmentService: AppointmentService,
    private readonly translate: TranslateService,
    private readonly clipboardApi: ClipboardService,
    private readonly formBuilder: FormBuilder,
    private readonly appLinkService: AppLinkService,
    private readonly toastr: ToastrService
  ) { }
  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.editcommentform = this.formBuilder.group({
      comment: ['', [Validators.required]],
    })
    this.isCurrentAppointmentOnHold = false;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.Customer);
    this.userRoleRightsDetailsVehicle = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find((menu) => menu.moduleId === Enums.ModuleNames.Vehicle);
    if (this.commonService.editAppointmentService.appointmentDetails?.workOrderStatusId) {
      this.previousStatus = this.commonService.editAppointmentService.appointmentDetails.workOrderStatusId;
      this.previousDocumentStatus = this.commonService.editAppointmentService.appointmentDetails.documentPartStatus;
      this.commonService.SelectedDocumentPartStatus = this.commonService.editAppointmentService.appointmentDetails.documentPartStatus;
    }
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.commonService.isRentalService = this.featureList.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive
        this.commonService.genericRentalCar = this.featureList.find(x => x.featureCode === Enums.FeatureCode.GRentalCar)?.isActive;
        this.isDocumentPartStatusActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DocumentPartStatus)?.isActive;
        this.isShiftAppointment = this.featureList.find(x => x.featureCode === Enums.FeatureCode.ShiftAppointment)?.isActive;
        this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.isDmsPackageSync = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
        this.isShareBoxEnabled = this.featureList.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
        this.isToAddRentalCarAsDemand = this.featureList.find(x => x.featureCode === Enums.FeatureCode.RentalCarAsDemand)?.isActive;
        this.isDsoActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DWO)?.isActive;
        this.isNeedAttention = this.featureList.find(x => x.featureCode === Enums.FeatureCode.NeedAttention)?.isActive;
        this.isDiscountCodeActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DiscountCode)?.isActive;
        this.isTireHotelActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.TireHotel)?.isActive;
      }
    }
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.getStatusBrand(this.commonService.editAppointmentService.appointmentDetails.dealerId, this.commonService.editAppointmentService.appointmentDetails.id, x);
    });
    this.GetAll();
    this.VatSub = this.currentLanguageService.vatSubject.subscribe(x => {
      this.VAT = x;
    })
    if (this.commonService.genericRentalCar) {
      this.selectedGenericRentalCarId = this.commonService.contactDetails?.genericRentalCarTypeId;
    }
    this.fillCustomerDropDownForPickUpDrop();
    this.commonService.GetDefaultShift();
    this.commonService.getComments(this.commonService.appointmentDetails.appointmentId);
    this.getServiceCampaignOption();
    this.getTransportSolution();
    this.commonService.getServiceAdvisorDetails(this.commonService.appointmentDetails.dealerId);
  }

  async GetAll() {
    this.commonService.appointmentDetails = this.commonService.editAppointmentService.appointmentDetails;
    if (this.commonService.appointmentDetails?.workOrderStatusId) {
      if (this.commonService.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed || this.commonService.appointmentDetails.workOrderStatusId === Enums.WOStatus.Cancelled) {
        this.SelectedStatus = this.commonService.appointmentDetails.workOrderStatusId;
        this.StatusDisabled = true;
      }
      else {
        this.SelectedStatus = null;
      }
    }
    if (this.commonService.editAppointmentService.appointmentDetails.appointmentType == "Quote") {
      this.isQuote = true;
    }
    this.appointmentStatusName = this.commonService.appointmentDetails.appointmentStatus;
    this.commonService.SelectedDocumentPartStatus = this.commonService.appointmentDetails.documentPartStatus;
    this.globalSetting.getAppointmentStatusName(this.commonService.appointmentDetails.appointmentStatusId)
  }

  async GetAppointmentDetail(Id: number, Guid: string) {
    this.spinner.show();
    this.commonService.GetAppointmentDetail(Id).then((result) => {
      if (result != null) {
        if(this.commonService.nomineeMobileCode != null){
          this.onInitSetContactMobileCode(this.commonService.nomineeMobileCode.toString());
        }
        if(this.commonService.mobileCode != null){
          this.onInitSetSellToMobileCode(this.commonService.mobileCode.toString());
        }
        this.initMobileNumbers();
        let appointmentDate = Utility.getDateStringToDate(this.commonService.appointmentPKKDate);
        if (result?.deliveryTime == null || result?.finishedTime == null) {
          this.commonService.DeliveryDate = null;
          this.commonService.FinnishedDate = null;
          this.commonService.deliveryTimeSlot = null;
          this.commonService.finishTimeSlot = null;
        }
        let todaysDate = new Date();
        if (appointmentDate >= todaysDate) {
          if (appointmentDate.getMonth() - todaysDate.getMonth() + 1 == 4) {
            this.DateClass = "GreenText"
          }
          else if (appointmentDate.getMonth() - todaysDate.getMonth() + 1 == 2) {
            this.DateClass = "YellowText"
          }
          else {
            this.DateClass = ""
          }
        }
        else {
          this.DateClass = "RedText"
        }
        this.spinner.hide();
        this.onGetContactDetails.emit(result);
      }
    },
      _error => {
        this.spinner.hide()
      });
  }

  getServiceCampaignOption(){
    this.appointmentService.getServiceCampaignOption().then((res) => {
      if (res != null) {
        this.serviceCampaignOptionList = res.responseObject;
      }});  
  }

  getTransportSolution(){
    this.availableTransport = this.commonService.appointmentDetails?.transportSolution?.split(',') as [];
  }

  isTransportAvailable(transportId: string): boolean {
    return this.availableTransport && this.availableTransport.includes(transportId);
  }

  isTextEmpty(): boolean {
    const text = this.commonService.contactDetails.campaignServiceText;
    return !text || text.trim() === '' || text.length > 150;
  }

  onNomineeCountryChange(obj) {
    if (this.isInitialLoad) {
      this.telNomineeInputObject();
      this.commonService.contactDetails.nomineeMobileCode = this.commonService.contactDetails.nomineeMobileCode || obj.dialCode;
      this.isInitialLoad = false;
    } else {
      this.commonService.contactDetails.nomineeMobileCode = obj.dialCode;
    }
  }
  telNomineeInputObject() {
    if (this.commonService.contactDetails.nomineeMobileCode) {
      let countryCode = this.getCountryCodeByDialCode(this.commonService.contactDetails.nomineeMobileCode.toString());
      this.selectedContactCountryISO = countryCode || this.cultureLocaleService.getLocale();
    }
    else {
      this.selectedContactCountryISO = this.cultureLocaleService.getLocale();
      this.deafultDialCode = this.getDialCodeByCountryCode(this.selectedContactCountryISO);
    }
  }
  /**
   * Seeds the tel-input models with plain strings, once, after the appointment detail is
   * loaded. Deliberately a one-time copy: re-coercing the model on every change would fight
   * the control's own writeValue/propagateChange cycle and make the field flicker.
   */
  initMobileNumbers() {
    if (this.mobileInitialized) {
      return;
    }
    this.contactMobileNo = this.toPhoneNumberString(this.commonService.singlePhoneNo);
    this.sellToCustomerMobileNo = this.toPhoneNumberString(this.commonService.mobileNo);
    this.mobileInitialized = true;
  }

  /** Unwraps a ngx-intl-tel-input ChangeData object (possibly nested) down to its number. */
  toPhoneNumberString(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return typeof value === 'string' ? value : this.toPhoneNumberString(value.number);
  }
  onInitSetContactMobileCode(dialCode:any){
    if(dialCode[0]==="+")
    {
      dialCode = dialCode.slice(1);
    }
    this.selectedContactCountryISO = this.getCountryCodeByDialCode(dialCode.toString())
  }
  onInitSetSellToMobileCode(dialCode:any){
    if(dialCode[0]==="+")
    {
      dialCode = dialCode.slice(1);
    }
    this.selectedSellCountryISO = this.getCountryCodeByDialCode(dialCode.toString())
  }
  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }
  getDialCodeByCountryCode(countryCode) {
    const country = this.countryDialCodes.find(c => c.countryCode === countryCode);
    return country ? country.dialCode : null;
  }
  mobileNumberChanged() {
    // Push the edited number back to the shared model as a plain string, never as the
    // control's ChangeData object.
    const contactMobile = this.toPhoneNumberString(this.contactMobileNo).replace(/\s+/g, '');
    this.commonService.singlePhoneNo = contactMobile;
    this.commonService.contactDetails.singlePhoneNo = contactMobile;
    if ((this.commonService.contactDetails.nomineeMobileCode === null ||
      this.commonService.contactDetails.nomineeMobileCode === '' ||
      this.commonService.contactDetails.nomineeMobileCode === undefined)
      && this.deafultDialCode) {
      this.commonService.contactDetails.nomineeMobileCode = this.deafultDialCode;
    }
  }
  getStatusBrand(dealerId: string, appointmentId: number, languageCode: string) {
    this.commonService.getStatusBrand(dealerId, appointmentId, languageCode).then(res => {
      if (this.commonService.editAppointmentService.appointmentDetails?.appointmentGuid) {
        this.GetAppointmentDetail(this.commonService.editAppointmentService.appointmentDetails.id, this.commonService.editAppointmentService.appointmentDetails.appointmentGuid);
      }
    })
  }

  fillCustomerDropDownForPickUpDrop(): void {
    this.CustomerDropTimeDropDownValues = [{
      name: 'lblWithinBusinessHour',
      value: false
    }
      // ,{
      //   name: this.isShareBoxEnabled ? 'lblOutsideOpeningHours-useShareBox' : 'lblOutsideOpeningHours-usekeyDrop',
      //   value: true
      // }
    ];
    this.CustomerPickUpTimeDropDownValues = [{
      name: 'lblWithinBusinessHour',
      value: false
    }
      // ,{
      //   name: this.isShareBoxEnabled ? 'lblOutsideOpeningHours-useShareBox' : 'lblOutsideOpeningHours-usekeyDrop',
      //   value: true
      // }
    ];
    //if (this.isShareBoxEnabled) { -- temp added for bnh, not a feature based.
    let outsideOpeningHrsOption = {
      name: 'lblOutsideOpeningHours-useShareBox',
      value: true
    }
    this.CustomerDropTimeDropDownValues.push(outsideOpeningHrsOption)
    this.CustomerPickUpTimeDropDownValues.push(outsideOpeningHrsOption)
    //}
  }
  onCustomerDropTimeSelected(event: any) {
    this.commonService.contactDetails.isKeyDrop = event;
    this.emitAppointmentDetail();
  }
  emitAppointmentDetail() {
    this.updatedAppointmentDetails.emit({
      updatedAppointmentValues: this.commonService.contactDetails,
      selectedRentalCarDetail: this.selectedRentalCarDetail,
    });
    this.onGetContactDetails.emit(this.commonService.contactDetails);
  }
  onChangeDeliveryDate(event: any) {

    this.commonService.contactDetails.deliveryTime = Utility.getDateStringToDate(event);
    this.commonService.contactDetails.deliveryTime?.setHours(this.commonService.deliveryTimeSlot.hour);
    this.commonService.contactDetails.deliveryTime?.setMinutes(this.commonService.deliveryTimeSlot.minute);
    this.emitAppointmentDetail();
  }
  onChangeDeliveryTime(time: any): void {
    this.commonService.contactDetails.deliveryTime?.setHours(time?.hour ?? 0);
    this.commonService.contactDetails.deliveryTime?.setMinutes(time?.minute ?? 0);
    this.emitAppointmentDetail();
  }
  onChangeFinnishedDate(event: any) {
    this.commonService.contactDetails.finishedTime = Utility.getDateStringToDate(event);
    this.commonService.contactDetails.finishedTime?.setHours(this.commonService.finishTimeSlot.hour);
    this.commonService.contactDetails.finishedTime?.setMinutes(this.commonService.finishTimeSlot.minute);
    this.emitAppointmentDetail();
  }
  onChangeFinnishedTime(time: any): void {
    this.commonService.contactDetails.finishedTime?.setHours(time?.hour ?? 0);
    this.commonService.contactDetails.finishedTime?.setMinutes(time?.minute ?? 0);
    this.emitAppointmentDetail();
  }
  onSelectCustomerWaitingCheckBox() {
    if (this.commonService.contactDetails.isCustomerWaiting) {
      //maintain the rental car selection , remove rent car if selected?
      this.commonService.contactDetails.isKeyDrop = undefined;
      this.commonService.contactDetails.isAutoKey = undefined;
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = null;
      this.commonService.contactDetails.rentalCompanyMakeName = null;
      this.commonService.contactDetails.priceForDisply = null;
      this.commonService.contactDetails.price = 0;
      this.selectedRentalCarDetail = null;
      this.commonService.workOrderService.isDisableSaveButton = false;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.selectedGenericRentalCarId = null;
    }
    else {
      this.commonService.contactDetails.isKeyDrop = this.contactDetailsCopiedData?.isKeyDrop;
      this.commonService.contactDetails.isAutoKey = this.contactDetailsCopiedData?.isAutoKey;
    }
    this.emitAppointmentDetail();
  }
  OpenRentalCarListPopup(Content) {
    this.spinner.show();
    this.selectedRentalCarId = null;
    this.commonService.getRentalCar();
    this.modalService.open(Content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }

  onSelectRentalCarCheckBox(value: boolean) {
    if (!this.commonService.contactDetails.isRentalCarSelected) {
      this.RentalCarValidationCheckBox = false;
    }
    if (!this.RentalCarValidationCheckBox && this.commonService.contactDetails.isRentalCarSelected) {
      this.commonService.workOrderService.isDisableSaveButton = true;
      this.commonService.contactDetails.rentalPrice = '';
      this.commonService.contactDetails.rentalVehicleId = '0';
      this.commonService.contactDetails.typeId = 0;
    }
    if (!this.RentalCarValidationCheckBox && !this.commonService.contactDetails.isRentalCarSelected) {
      this.commonService.workOrderService.isDisableSaveButton = false;
    }
    if (!this.commonService.contactDetails.isRentalCarSelected && value) {
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = this.contactDetailsCopiedData.rentalVehicleId;
      this.commonService.contactDetails.rentalCompanyMakeName = this.contactDetailsCopiedData.rentalCompanyMakeName;
      this.commonService.contactDetails.price = this.contactDetailsCopiedData.price;
      this.selectedRentalCarDetail = null;
      this.commonService.workOrderService.isDisableSaveButton = false;
    }
    if (!this.commonService.contactDetails.isRentalCarSelected && !value) {
      this.commonService.availRentalCarList = [];
      this.commonService.contactDetails.rentalVehicleId = null;
      this.commonService.contactDetails.rentalCompanyMakeName = null;
      this.commonService.contactDetails.priceForDisply = null;
      this.commonService.contactDetails.price = 0;
      this.selectedRentalCarDetail = null;
      this.commonService.workOrderService.isDisableSaveButton = false;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.selectedGenericRentalCarId = null;
      if (this.isToAddRentalCarAsDemand) {
        this.unselectRentalCar.emit(this.commonService.contactDetails.isRentalCarSelected);
      }
    }
    if (this.commonService.contactDetails.isRentalCarSelected && !this.commonService.genericRentalCar && !this.contactDetailsCopiedData.rentalVehicleId) {
      this.commonService.workOrderService.isDisableSaveButton = true;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar && !this.commonService.contactDetails.rentalCompanyMakeName) {
      this.commonService.workOrderService.isDisableSaveButton = true;
    }
    if (!this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar) {
      this.onRentalCarSelected();
    }
  }
  onRentalCarSelected() {
    if (this.selectedRentalCarId && !this.commonService.genericRentalCar) {
      this.commonService.workOrderService.isRentalCarUpdated = true;
      this.RentalCarValidationCheckBox = true;
      this.selectedRentalCarDetail = this.commonService.availRentalCarList.filter(x => x.vehicleId === this.selectedRentalCarId)[0];
      this.commonService.contactDetails.rentalVehicleId = this.selectedRentalCarDetail.vehicleId.toString();
      this.commonService.contactDetails.rentalCompanyMakeName = this.selectedRentalCarDetail.makeName;
      this.commonService.contactDetails.price = this.selectedRentalCarDetail.price;
      this.commonService.contactDetails.priceForDisply = this.selectedRentalCarDetail.price;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.contactDetails.rentalVehicleId && !this.commonService.genericRentalCar) {
      this.commonService.workOrderService.isDisableSaveButton = false;
    }
    if (this.selectedGenericRentalCarId && this.commonService.genericRentalCar) {
      let details: RentalCar = {
        vehicleId: 0,
        makeName: '',
        model: '',
        licensePlate: '',
        price: 0
      }
      this.selectedRentalCarDetail = details;
      this.commonService.contactDetails.isGenericRentalCar = this.commonService.genericRentalCar;
      this.commonService.workOrderService.isRentalCarUpdated = true;
      let model = this.commonService.genericRentalCarList.filter(x => x.typeId === this.selectedGenericRentalCarId)[0];
      if (model == undefined) {
        this.selectedRentalCarDetail.makeName = this.commonService.contactDetails.rentalCompanyMakeName;//rentalCompanyMakeName
        this.selectedRentalCarDetail.model = this.commonService.contactDetails.priceForDisply;//priceForDisply
        this.selectedRentalCarDetail.rentalCarType = this.commonService.contactDetails.rentalCompanyMakeName;//rentalCompanyMakeName
        this.selectedRentalCarDetail.rentalCarPrice = this.commonService.contactDetails.priceForDisply;//priceForDisply
      }
      else {
        this.selectedRentalCarDetail.makeName = model.type;//rentalCompanyMakeName
        this.selectedRentalCarDetail.model = model.price;//priceForDisply
        this.selectedRentalCarDetail.rentalCarType = model.type;//rentalCompanyMakeName
        this.selectedRentalCarDetail.rentalCarPrice = model.price;//priceForDisply
        this.commonService.contactDetails.rentalCompanyMakeName = model.type;//rentalCompanyMakeName
        this.commonService.contactDetails.genericRentalCarTypeId = model.typeId; //genericRentalCarTypeId
        this.commonService.contactDetails.priceForDisply = model.price; //priceForDisply
      }
      this.commonService.contactDetails.rentalVehicleId = "0";
      this.commonService.contactDetails.price = 0;
    }
    if (this.commonService.contactDetails.isRentalCarSelected && this.commonService.genericRentalCar) {
      this.commonService.workOrderService.isDisableSaveButton = false;
    }
    this.emitAppointmentDetail();
  }
  OnHoldStatusChange() {
    const modalref = this.modalService.open(OnholdStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.currentWorkorderStatusId = this.commonService.appointmentDetails.workOrderStatusId;
    modalref.componentInstance.appointmentId = this.commonService.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.commonService.contactDetails.workOrderNo;
    modalref.result.then((response) => {
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      else {
        this.resetCalculations()
      }
    }, _error => {
    });
  }
  OnCancelStatusChange() {
    const modalref = this.modalService.open(CancelStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.appointmentId = this.commonService.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.commonService.contactDetails.workOrderNo;
    modalref.componentInstance.appointmentType = this.commonService.appointmentDetails.appointmentType;
    modalref.componentInstance.appointmentGuid = this.commonService.editAppointmentService.appointmentDetails.appointmentGuid;
    modalref.componentInstance.brandCode = this.commonService.appointmentDetails.brandCode;
    modalref.result.then((response) => {
      //status update
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      //remove selected on hold status
      else {
        this.resetCalculations()
      }
    }, _error => {
      // This is intentional
    });
  }

  async onStatusChange() {
    if (this.SelectedStatus != null || this.SelectedStatus != undefined) {
      if (this.SelectedStatus === Enums.WOStatus.Workdone) {
        let isAnyDemand = await this.GetAdditionalServiceDetail();
        if (!isAnyDemand) {
          this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
          this.commonService.SelectedStatus = this.SelectedStatus;
        }
        else {
          let msg = this.translate.instant("lblWorkDoneStatusError");
          this.toastr.error(msg);
          this.SelectedStatus = null;
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.Prepared) {
        if (this.commonService.appointmentDetails.workOrderStatus == Enums.WOStatusName.Cararrived) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblCarArrivedstatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblPrepared"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if (reason) {
              this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
              this.commonService.SelectedStatus = this.SelectedStatus;
            }
            else {
              this.SelectedStatus = null;
            }
          });
        }
        else {
          this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
          this.commonService.SelectedStatus = this.SelectedStatus;
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.OnHold) {
        if (this.commonService.appointmentDetails.workOrderStatus == Enums.WOStatusName.Mechanicdone) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblMechanicDoneStatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblOnHoldStatus"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if (reason) {
              this.OnHoldStatusChange();
            }
            else {
              this.SelectedStatus = null;
            }
          });
        }
        else {
          this.OnHoldStatusChange();
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.Cancelled) {
        this.OnCancelStatusChange()
      }
      else {
        this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
        this.commonService.SelectedStatus = this.SelectedStatus;
      }
    }
  }

  async GetAdditionalServiceDetail() {
    let isAnyDemand = false;
    const data = await this.appointmentService.GetAdditionalServiceDetail(this.editAppointmentService.appointmentDetails.id);
    if (data.responseObject != null) {
      let appointmentDemandList = data.responseObject.appointmentDemandList;
      if (appointmentDemandList.length > 0) {
        let additionalDemand = appointmentDemandList.filter(x => x.demandNo > 100 && x.isAdditionalWork == true);
        if (additionalDemand.length > 0) {
          let pendingAdditionalDemand = additionalDemand.filter(x => x.isAdminApproved == 0 && x.isCustomerApporved == 0 && x.isMechanicApproved == 0 && x.isCDSSApproved == 0);
          if (pendingAdditionalDemand.length > 0) {
            isAnyDemand = true;
          }
        }
      }
    }
    return isAnyDemand;
  }
  resetCalculations() {
    this.SelectedStatus = null;
    this.commonService.appointmentDetails.workOrderStatusId = this.previousStatus;
    this.commonService.SelectedStatus = null;
  }

  onCustomerPickUpTimeSelected(event: any) {
    this.commonService.contactDetails.isAutoKey = event;
    this.emitAppointmentDetail();
  }

  async UpdateNeedAttention() {
    await this.commonService.UpdateNeedAttention().then((response) => {
      if (response) {
        this.isRefreshTab.emit(true);
      }
    });
  }

  public onChangeCampaignService() {
    if(this.commonService.contactDetails.campaignServiceId == 1){
      this.commonService.contactDetails.campaignService = false;
    }
    else{
      this.commonService.contactDetails.campaignService = true;
    }
    this.emitAppointmentDetail();
  }

  public onChangeImportedCar(event: any) {
    this.commonService.contactDetails.importedCar = event;
    this.emitAppointmentDetail();
  }

  public onChangeToweinCar(event: any) {
    this.commonService.contactDetails.toweinCars = event;
    this.emitAppointmentDetail();
  }

    public onChangeTireHotel(event: any) {
    this.commonService.contactDetails.isTireHotel = event;
    this.emitAppointmentDetail();
  }
  
  public generateStatusTrackerLink(data) {
    let model = {
      AppointmentGuid: data.AppointmentGuid
    };
    this.appLinkService.AddTrackerLink(model)
      .then(
        _res => {
          this.appLinkService.GetTrackerLink(model.AppointmentGuid).then(x => {
            this.editAppointmentService.trackerURL = x;
          }, _error => { this.spinner.hide(); })

          let successMessage = this.translate.instant("lblTrackerLinkGenerated");
          this.toastr.success(successMessage);

        },
        err => {
          console.error('HTTP Error', err);
        }
      );
  }

  async generateAndSendTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      let isTrackerLinkGenerated = false;
      if(this.editAppointmentService.trackerURL)
      {
        isTrackerLinkGenerated=true;
      }
      else
      {
        let data = {
          AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.generateStatusTrackerLink(data);
        isTrackerLinkGenerated = true;
      }
      await this.appLinkService.SendTrackerSms(this.editAppointmentService.appointmentDetails.appointmentGuid).then(_x => {
        if (_x === "true" && isTrackerLinkGenerated) {
          let successMessage = this.translate.instant("lblTrackerLinkIsGeneratedAndMessageSent");
          this.toastr.success(successMessage);
        }
        else {
          let failMessage = this.translate.instant("lblFailedToSentTrackerLink");
          this.toastr.error(failMessage);
        }
      }, _error => {
        console.error('HTTP Error', _error);
      })
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  async generateAndSendCheckinLink() {
    if (this.commonService.appointmentBookedDate) {
      await this.appLinkService.SendCheckInSms(this.editAppointmentService.appointmentDetails.id).then(_x => {
        if (_x === "true") {
          let successMessage = this.translate.instant("lblCheckInLinkIsGeneratedAndMessageSent");
          this.toastr.success(successMessage);
        }
        else {
          let failMessage = this.translate.instant("lblFailedToSentCheckInLink");
          this.toastr.error(failMessage);
        }
      }, _error => {
        console.error('HTTP Error', _error);
      })
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }

  }

  generateTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      if (this.editAppointmentService.trackerURL) {
        let warningMessage = this.translate.instant("lblTrackerLinkAlreadyGenerated");
        this.toastr.warning(warningMessage);
      }
      else {
        let data = {
          AppointmentGuid: this.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.generateStatusTrackerLink(data);
      }
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  copyInternalComments() {
    this.clipboardApi.copyFromContent(this.commonService.internalComment)
  }

  copyCustomerComments() {
    this.clipboardApi.copyFromContent(this.commonService.customerComment)
  }

  copyMechanicComments(){
    this.clipboardApi.copyFromContent(this.commonService.mechanicComment)
  }

  getTruncatedComment(comment: string): string {
    if (!comment) {
      return '';
    }
    return comment.length > 30 ? comment.substring(0, 30) + '...' : comment;
  }
  open(Internalcontent) {
    this.modalService.open(Internalcontent, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }

  AddInternalComment() {
    if (this.commonService.internalCommentData.trim()) {
      this.commonService.AddInternalComment();
      this.commonService.internalCommentData = null;
    }
    else {
      let noSpaceAllowedInComment = this.translate.instant("lblOnlySpaceNotAllowed");
      this.toastr.error(noSpaceAllowedInComment);
    }
  }

  ViewComment(viewContent, commentType) {
    this.commentType = commentType;
    this.commonService.CommentsByCount(commentType);
    this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.commonService.getDismissReason(reason)}`;
    });
  }

  EditComment(editcontent, comment) {
    this.editCommentText = comment.comment;
    this.editCommentId = comment.id;
    this.closeModel = this.modalService.open(editcontent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
  }

  EditCommentDetails() {
    this.commonService.EditCommentDetails(this.editCommentText, this.editCommentId);
    this.closeModel.close();
  }

  DeleteComment(Comments: any) {
    this.commonService.DeleteComment(Comments);
  }

  onChangeTransportSolution(transportSolution: any) {
    if (transportSolution == 1) {
      this.commonService.appointmentDetails.noNeedTransport = true;
      this.commonService.appointmentDetails.needTransportTicket = false;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.commonService.contactDetails.isGenericRentalCarSelected = false;
      this.onSelectRentalCarCheckBox(false);
    }
    if (transportSolution == 2) {
      this.commonService.appointmentDetails.noNeedTransport = false;
      this.commonService.appointmentDetails.needTransportTicket = true;
      this.commonService.contactDetails.isRentalCarSelected = false;
      this.commonService.contactDetails.isGenericRentalCarSelected = false;
      this.onSelectRentalCarCheckBox(false);
    }
    if (transportSolution == 3) {
      this.commonService.appointmentDetails.noNeedTransport = false;
      this.commonService.appointmentDetails.needTransportTicket = false;
      this.commonService.contactDetails.isRentalCarSelected = true;
      this.commonService.contactDetails.isGenericRentalCarSelected = true;
      this.onSelectRentalCarCheckBox(false);
    }
  }

  onServiceAdvisorChange(value: any) {
    if (value == null) {
      this.commonService.contactDetails.isAuthorizedByServiceAdvisor = false;
    }
  }

  onServiceAdvisorAuthorizationChange(event: any) {
    if(event.target.checked){
      this.commonService.contactDetails.isAuthorizedByServiceAdvisor = true;
    }
    else{
      this.commonService.contactDetails.isAuthorizedByServiceAdvisor = false;
    }
  } 
}